<div class="organizer-shared-page-container container p-0">
  <header
    *ngIf="showStepperTabBar"
    class="organizer-shared-page-container__header-nav col-span-12 container 2xl:max-w-none"
  >
    <nav class="col-span-12 md:col-span-10 md:col-start-2">
      <app-stepper-tab-bar
        [collection]="stepperTabBarCollection"
        [activeIndex]="activeStep"
      ></app-stepper-tab-bar>
    </nav>
  </header>
  <div
    *ngIf="
      !isAllowExternalPayment && isInvalidStripeAccount && showStepperTabBar
    "
    class="organizer-shared-page-container__invalid-status"
  >
    <div class="p-2 text-center bg-vtmn-play-content-brand text-white">
      <p class="mb-1" [innerHTML]="stripeLink"></p>
    </div>
  </div>
  <div
    class="organizer-shared-page-container__content col-span-12 md:col-start-2"
    [class.organizer-shared-page-container__content--header-spacing]="
      showStepperTabBar
    "
    [class.md:col-span-5]="!hasSingleColumn"
  >
    <ng-content></ng-content>
  </div>
  <div
    *ngIf="showRightContent"
    class="organizer-shared-page-container__right-content col-span-12 md:col-span-4 md:col-start-8"
    [class.organizer-shared-page-container__right-content--header-spacing]="
      showStepperTabBar
    "
  >
    <app-tips
      class="organizer-shared-page-container__right-content__tip"
      *ngFor="let tip of tips"
      [title]="tip.header"
      [tips]="tip.description"
      [variant]="tip.variant"
      [icon]="tip.iconName"
    >
    </app-tips>
  </div>
</div>
